import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";

const NotValidatedRow = () => {
  return <>
    <div className="flex">
      <div className="margin-right">
        <PhosphorWarning iconSize="large" />
      </div>
      <div>
        <div>{RESX.Planning.NotYetChecked}</div>
        <div className="text-sublabel">{RESX.Planning.InputFromWebform}</div>
      </div>
    </div>
  </>;
};

export default NotValidatedRow;